import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#EF4444', '#F59E0B', '#3B82F6'];

const CancellationsChart = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Cancellations & Returns</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Cancelled</small>
                            <strong className="text-danger">{data.total_cancelled}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Returned</small>
                            <strong className="text-warning">{data.total_returned}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Revenue Lost</small>
                            <strong className="text-danger">{data.revenue_lost?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                </div>
                {data.cancelled_by_reason && data.cancelled_by_reason.length > 0 && (
                    <>
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Cancellations by Reason</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Reason</th>
                                        <th className="text-end">Count</th>
                                        <th className="text-end">Revenue Lost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.cancelled_by_reason.map((r, i) => (
                                        <tr key={i}>
                                            <td>{r.reason}</td>
                                            <td className="text-end">{r.count}</td>
                                            <td className="text-end">{r.revenue_lost?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CancellationsChart;
